import React, { Component } from 'react';

import { flatten } from 'lodash';
import { useTranslation } from 'react-i18next';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/pro-light-svg-icons';


import LinksList from '../LinksList';
import ActionButton from 'components/action/ActionButton';
import { Flex } from 'antd';

import UIContext from 'components/Utils/UIContext';

export const LinksTab = (props: any) => {
	const { t } = useTranslation();
	const uiContext = React.useContext(UIContext);
	const locked = props.scenario || !uiContext.canEdit;

	const targetLinks =
		props.selection && props.stakeholders
			? flatten(props.stakeholders.map((c) => c.links)).filter((l) => {
				return l.targetId == props.selection.id;
			})
			: [];

	return (
		<>
			<Flex vertical className="mt-1">
				<div>
					<div className="text-left">
						{t('models.item.fields.links.outcoming.name')}
					</div>
					<LinksList
						onDelete={
							locked
								? null
								: (id: string) =>
									props.onDeleteStakeholderLink(
										props.selection.id,
										id
									)
						}
						onCycleStrength={
							locked
								? null
								: props.onChangeStakeholderLinkStrength
						}
						items={
							props.indexedStakeholders &&
								props.indexedStakeholders[props.selection.id]
								? props.indexedStakeholders[
									props.selection.id
								].links.map((l: any) => {
									return {
										...l,
										name: props.indexedStakeholders[
											l.targetId
										].name
									};
								})
								: []
						}
					></LinksList>
					{props.indexedStakeholders &&
						props.indexedStakeholders[props.selection.id]
						? props.indexedStakeholders[props.selection.id].links
							.length == 0 && (
							<div
								style={{ color: 'var(--ant-color-text-tertiary)' }}
							>
								{t('models.item_link.no_x')}
							</div>
						)
						: null}

					<div className="text-left mt-2">
						{t('models.item.fields.links.incoming.name')}
					</div>
					<LinksList
						onCycleStrength={
							locked
								? null
								: props.onChangeStakeholderLinkStrength
						}
						items={targetLinks.map((l: any) => {
							return {
								...l,
								name: props.indexedStakeholders[l.originId].name
							};
						})}
					></LinksList>

					{targetLinks.length == 0 && (
						<div style={{ color: 'var(--ant-color-text-tertiary)' }}>
							{t('models.item_link.no_x')}
						</div>
					)}
				</div>

				{!locked && (
					<div className="Actions m-auto mt-1">
						<ActionButton
							tooltip={t('models.item_link.actions.create_new')}
							className="createStakeholderLink small"
							onClick={props.onCreateLink}
						>
							<FontAwesomeIcon icon={faLink} />
						</ActionButton>
					</div>
				)}
			</Flex>
		</>
	);
};

export default LinksTab;
